/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Portals_VrInputs */

const cs_property_portals_vr = /** @type {(inputs: Property_Portals_VrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virtuální prohlídka a panorama`)
};

const en_property_portals_vr = /** @type {(inputs: Property_Portals_VrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virtual tour & panorama`)
};

/**
* | output |
* | --- |
* | "Virtual tour & panorama" |
*
* @param {Property_Portals_VrInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_portals_vr = /** @type {((inputs?: Property_Portals_VrInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Portals_VrInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_portals_vr(inputs)
	return cs_property_portals_vr(inputs)
});